import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const InfoFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12ZM13.25 7C13.25 7.33152 13.1183 7.64946 12.8839 7.88388C12.6495 8.1183 12.3315 8.25 12 8.25C11.6685 8.25 11.3505 8.1183 11.1161 7.88388C10.8817 7.64946 10.75 7.33152 10.75 7C10.75 6.66848 10.8817 6.35054 11.1161 6.11612C11.3505 5.8817 11.6685 5.75 12 5.75C12.3315 5.75 12.6495 5.8817 12.8839 6.11612C13.1183 6.35054 13.25 6.66848 13.25 7ZM10.75 10.75C10.4185 10.75 10.1005 10.8817 9.86612 11.1161C9.6317 11.3505 9.5 11.6685 9.5 12C9.5 12.3315 9.6317 12.6495 9.86612 12.8839C10.1005 13.1183 10.4185 13.25 10.75 13.25V17C10.75 17.3315 10.8817 17.6495 11.1161 17.8839C11.3505 18.1183 11.6685 18.25 12 18.25H13.25C13.5815 18.25 13.8995 18.1183 14.1339 17.8839C14.3683 17.6495 14.5 17.3315 14.5 17C14.5 16.6685 14.3683 16.3505 14.1339 16.1161C13.8995 15.8817 13.5815 15.75 13.25 15.75V12C13.25 11.6685 13.1183 11.3505 12.8839 11.1161C12.6495 10.8817 12.3315 10.75 12 10.75H10.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

InfoFilledIcon.displayName = 'InfoFilledIcon';
